import React from 'react'
import '../css/Footer.css'

export default props =>
    <footer className="footer px-2">
        <span>
            Desenvolvido com<i className="fa fa-heart text-primary mx-1" /> 
             pela <strong> CUBOH</strong>
        </span>
    </footer>